// NEST CUSTOM JAVASCRIPT

// Fonts Loading
// HWT Artz - Local files
// Sofia Pro Soft - Local files
// Fraunces - Google Fonts CDN

// Console log to confirm file loaded
console.log("nest-custom.js loaded");

document.addEventListener('DOMContentLoaded', function() {
  // Variant selection for PDP
  const variantRadios = document.querySelectorAll('input[name="variant-option"]');
  const productFormIdInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  
  if (variantRadios.length > 0 && productFormIdInput) {
    variantRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        productFormIdInput.value = this.value;
        console.log("Selected variant ID:", this.value);
      });
    });
  }

  // Mobile menu toggle
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  const mobileDrawer = document.querySelector('.mobile-drawer');
  if (mobileMenuBtn && mobileDrawer) {
    const setMobileMenuState = function(isOpen) {
      mobileMenuBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileMenuBtn.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      mobileDrawer.classList.toggle('open', isOpen);
      mobileDrawer.hidden = !isOpen;
    };

    setMobileMenuState(false);

    mobileMenuBtn.addEventListener('click', function() {
      const isOpen = mobileMenuBtn.getAttribute('aria-expanded') === 'true';
      setMobileMenuState(!isOpen);
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && mobileMenuBtn.getAttribute('aria-expanded') === 'true') {
        setMobileMenuState(false);
        mobileMenuBtn.focus();
      }
    });

    mobileDrawer.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        setMobileMenuState(false);
      });
    });
  }

  document.querySelectorAll('[data-accordion-trigger]').forEach(function(trigger) {
    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    const item = trigger.closest('.acc-item');

    if (!panel || !item) {
      return;
    }

    const syncAccordionState = function(isOpen) {
      item.classList.toggle('open', isOpen);
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.hidden = !isOpen;
    };

    syncAccordionState(trigger.getAttribute('aria-expanded') === 'true');

    trigger.addEventListener('click', function() {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      syncAccordionState(!isOpen);
    });
  });

  const successMessage = document.querySelector('.form-status--success[data-toast-message]');
  if (successMessage) {
    const toast = document.createElement('div');
    toast.className = 'nest-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = successMessage.dataset.toastMessage;
    document.body.appendChild(toast);

    requestAnimationFrame(function() {
      toast.classList.add('is-visible');
    });

    window.setTimeout(function() {
      toast.classList.remove('is-visible');
      window.setTimeout(function() {
        toast.remove();
      }, 220);
    }, 3200);
  }
});
